const types = {
  SET_LOOK_UP_USER_TYPES_LIST: 'SET_LOOK_UP_USER_TYPES_LIST',
};

export default types;
